import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Subtitle from '../../../components/Subtitle';
import DateTimePicker from '../../../times/components/DateTimePicker';

const PickTime = props => (
  <div className="u-pos-relative">
    <Subtitle>Choose date & time</Subtitle>
    <DateTimePicker {...props} />
    { props.nextLink && <div className="u-text-center">
      <Link
        to={props.nextLink}
        className="c-btn c-btn--primary u-mt"
      >
        Next
      </Link>
    </div> }
  </div>
);
PickTime.propTypes = {
  nextLink: PropTypes.string,
};
PickTime.defaultProps = {
  nextLink: '',
};

export default PickTime;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/components/PickTime.jsx